<span fxLayout="column">
  <span fxLayout="row" fxLayoutGap="10px" fxFlexOffset="15" fxFlexOffset.sm="30px" fxFlexOffset.xs="30px"
    fxLayoutAlign="start center" class="w-100 n-ml10px">
    <img alt="FLIMMO Prädikat" height="35" width="42" [src]="'assets/media/ico_praedikat.svg'" />
    <span class="mat-headline-1 center-h1 greentext-color">{{'besprechung.approved' | translate}}</span>
  </span>
  <span fxLayout="row" class="w-100" fxFlexOffset="10px" fxLayoutGap="36px" fxLayoutAlign="center center">
    <div fxFlex="24px"><mat-icon class="fs24">tag_faces</mat-icon></div>
    <span fxLayout="row" fxLayoutGap="5px" fxFlex="90" fxLayoutAlign="space-between center" class="bb-1-grey">
      <span class="m-auto mb1 itemPadding color-black-b" fxFlex="80">
        {{'besprechung.humor' | translate}}
      </span>
      <mat-icon fxFlex="10" class="greentext-color">{{getChecked('humor')}}</mat-icon>
    </span>
  </span>
  <span fxLayout="row" class="w-100" fxLayoutGap="36px" fxLayoutAlign="center center">
    <div fxFlex="24px"><mat-icon class="fs24">flash_on</mat-icon></div>
    <span fxLayout="row" fxLayoutGap="5px" fxFlex="90" fxLayoutAlign="space-between center" class="bb-1-grey">
      <span class="m-auto mb1 itemPadding color-black-b" fxFlex="80">
        {{'besprechung.spannung' | translate}}
      </span>
      <mat-icon fxFlex="10" class="greentext-color">{{getChecked('spannung')}}</mat-icon>
    </span>
  </span>
  <span fxLayout="row" class="w-100" fxLayoutGap="36px" fxLayoutAlign="center center">
    <div fxFlex="24px"><mat-icon class="fs24">school</mat-icon></div>
    <span fxLayout="row" fxLayoutGap="5px" fxFlex="90" fxLayoutAlign="space-between center" class="bb-1-grey">
      <span class="m-auto mb1 itemPadding color-black-b" fxFlex="80">
        {{'besprechung.wissen' | translate}}
      </span>
      <mat-icon fxFlex="10" class="greentext-color">{{getChecked('wissen')}}</mat-icon>
    </span>
  </span>
  <span fxLayout="row" class="w-100" fxLayoutGap="36px" fxLayoutAlign="center center">
    <div fxFlex="24px"><mat-icon class="fs24">escalator_warning</mat-icon></div>
    <span fxLayout="row" fxLayoutGap="5px" fxFlex="90" fxLayoutAlign="space-between center" class="bb-1-grey">
      <span class="m-auto mb1 itemPadding color-black-b" fxFlex="80">
        {{'besprechung.vorbild' | translate}}
      </span>
      <mat-icon fxFlex="10" class="greentext-color">{{getChecked('vorbild')}}</mat-icon>
    </span>
  </span>
  <span fxLayout="row" class="w-100" fxLayoutGap="36px" fxLayoutAlign="center center">
    <div fxFlex="24px"><mat-icon class="fs24">campaign</mat-icon></div>
    <span fxLayout="row" fxLayoutGap="5px" fxFlex="90" fxLayoutAlign="space-between center" class="bb-1-grey">
      <span class="m-auto mb1 itemPadding color-black-b" fxFlex="80">
        {{'besprechung.botschaft' | translate}}
      </span>
      <mat-icon fxFlex="10" class="greentext-color">{{getChecked('botschaft')}}</mat-icon>
    </span>
  </span>
  <span fxLayout="row" class="w-100" fxLayoutGap="36px" fxLayoutAlign="center center">
    <div fxFlex="24px"><mat-icon class="fs24">movie</mat-icon></div>
    <span fxLayout="row" fxLayoutGap="36px" fxFlex="90" fxLayoutAlign="space-between center">
      <span class="m-auto mb1 itemPadding color-black-b" fxFlex="80">
        {{'besprechung.machart' | translate}}
      </span>
      <mat-icon fxFlex="10" class="greentext-color">{{getChecked('machart')}}</mat-icon>
    </span>
  </span>
  <span fxFlex.xs="40px"></span>
</span>
